module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei5.svg";